<template>
    <div class="item-list">
        <voice-mail-item
                v-for="item in items"
                :key="item.id"
                :item="item"
                :active="active"
                class="item-list__item voice-message-pick-list__item"
                @select="select"
        ></voice-mail-item>
    </div>
</template>

<script>
  import {mapActions} from 'vuex';
  import VoiceMailItem from './voice-message-item';
  import AjaxErrorHandling from '../../mixins/ajax-errors';

  export default {
    components: {
      VoiceMailItem,
    },

    mixins: [
      AjaxErrorHandling
    ],

    props: {
      url: String,
    },

    data() {
      return {
        items: null,
        active: null,
      };
    },

    methods: {
      ...mapActions('voice', [
        'mail',
      ]),

      /**
       * @return {undefined}
       */
      getItems() {
        axios.get(this.url)
          .then(({data: {data}}) => {
            this.items = data;
            this.$emit('loaded-data', {count: _.size(data)});
          })
          .catch(this.handleErrorResponse);
      },

      /**
       * @param {number} id
       */
      select(id) {
        this.active = id;
        this.mail({audioId: id})
          .finally(() => this.active = null);
      },
    },

    mounted() {
      this.getItems();
    }
  }
</script>
